(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orelvon-event-card-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orelvon-event-card-price')) {
    customElements.define('orelvon-event-card-price', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        window.addEventListener('pageshow', () => this.checkExpiry(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.checkExpiry();
        }, { signal: this.abort.signal });
        this.checkExpiry();
      }

      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.expiryTimer);
        this.initialized = false;
      }

      checkExpiry() {
        clearTimeout(this.expiryTimer);
        const end = Date.parse(this.dataset.endAt?.trim() || '');
        const remaining = end - Date.now();
        const expired = !Number.isFinite(end) || remaining <= 0;
        this.hidden = expired;
        const fallback = this.parentElement?.querySelector('[data-event-base-price], [data-halloween-base-price]');
        if (fallback) fallback.hidden = !expired;
        if (!expired) this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(remaining + 25, 86400000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orelvon-event-sticky-total"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orelvon-event-sticky-total')) {
    customElements.define('orelvon-event-sticky-total', class extends HTMLElement {
      static get observedAttributes() { return ['data-base-price', 'data-unit-price', 'data-price-state', 'data-variant-id', 'data-end-at']; }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.section = this.closest('.shopify-section');
        document.addEventListener('quantity-selector:update', (event) => {
          if (event.detail?.cartLine || !(event.target instanceof Element) || !this.section?.contains(event.target)) return;
          this.updateTotal();
        }, { signal: this.abort.signal });
        window.addEventListener('pageshow', () => this.updateTotal(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.updateTotal();
        }, { signal: this.abort.signal });
        this.updateTotal();
      }

      attributeChangedCallback() {
        if (this.initialized) queueMicrotask(() => { if (this.isConnected) this.updateTotal(); });
      }

      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.expiryTimer);
        this.initialized = false;
      }

      updateTotal() {
        clearTimeout(this.expiryTimer);
        const end = Date.parse(this.dataset.endAt?.trim() || '');
        const remaining = end - Date.now();
        const expired = !Number.isFinite(end) || remaining <= 0;
        this.hidden = expired;
        const fallback = this.parentElement?.querySelector('[data-event-base-price]');
        if (fallback) fallback.hidden = !expired;
        if (expired) return;
        const input = this.section?.querySelector('product-form-component input[name="quantity"]');
        const quantity = Math.max(1, Math.floor(Number(input?.value || this.dataset.initialQuantity) || 1));
        const base = Number(this.dataset.basePrice);
        if (!Number.isFinite(base)) return;
        const unit = Number(this.dataset.unitPrice);
        if (!Number.isFinite(unit) || unit < 0 || unit > base) return;
        const subtotal = base * quantity;
        const tier = this.dataset.currency === 'USD' ? (subtotal >= 45000 ? 1500 : subtotal >= 30000 ? 1000 : subtotal >= 15000 ? 500 : 0) : 0;
        const amount = Math.max(0, unit * quantity - tier);
        const label = quantity === 1 ? this.dataset.labelOne : this.dataset.labelMany.replace('__COUNT__', String(quantity));
        const labelNode = this.querySelector('[data-event-total-label]');
        const amountNode = this.querySelector('[data-event-total-amount]');
        if (labelNode) labelNode.textContent = label;
        if (amountNode) amountNode.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(amount / 100);
        this.expiryTimer = setTimeout(() => this.updateTotal(), Math.min(remaining + 25, 86400000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orelvon-halloween-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orelvon-halloween-bar')) {
    customElements.define('orelvon-halloween-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.preview = this.dataset.preview === 'true';
        this.endAt = Date.parse(this.dataset.endAt?.trim() || '');
        this.previewNow = Date.parse(this.dataset.previewNow?.trim() || '');
        this.startedAt = performance.now();
        this.abort = new AbortController();
        this.disclosure = this.querySelector('.orelvon-halloween-bar__disclosure');
        this.summary = this.disclosure?.querySelector('summary');
        this.units = {
          days: this.querySelector('[data-halloween-days]'),
          hours: this.querySelector('[data-halloween-hours]'),
          minutes: this.querySelector('[data-halloween-minutes]'),
          seconds: this.querySelector('[data-halloween-seconds]')
        };
        this.disclosure?.addEventListener('toggle', () => this.queueHeight(), { signal: this.abort.signal });
        this.querySelector('[data-halloween-close]')?.addEventListener('click', () => this.closeOffer(true), { signal: this.abort.signal });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.disclosure?.open) this.closeOffer(true);
        }, { signal: this.abort.signal });
        document.addEventListener('click', (event) => {
          if (this.disclosure?.open && !this.contains(event.target)) this.closeOffer(false);
        }, { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.updateCountdown();
        }, { signal: this.abort.signal });
        window.addEventListener('pageshow', () => this.updateCountdown(), { signal: this.abort.signal });
        this.resizeObserver = new ResizeObserver(() => this.queueHeight());
        this.resizeObserver.observe(this);
        const group = this.closest('#header-group');
        if (group) {
          Array.from(group.children).forEach((element) => this.resizeObserver.observe(element));
          const header = group.querySelector('#header-component');
          if (header) this.resizeObserver.observe(header);
        }
        this.updateHeight();
        this.queueHeight();
        this.updateCountdown();
        if (!this.hidden && Number.isFinite(this.endAt)) this.timer = setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        clearInterval(this.timer);
        cancelAnimationFrame(this.heightFrame);
        document.body.style.removeProperty('--orelvon-halloween-bar-height');
        this.initialized = false;
      }

      closeOffer(restoreFocus) {
        if (!this.disclosure?.open) return;
        this.disclosure.open = false;
        if (restoreFocus) this.summary?.focus({ preventScroll: true });
        this.queueHeight();
      }

      queueHeight() {
        cancelAnimationFrame(this.heightFrame);
        this.heightFrame = requestAnimationFrame(() => this.updateHeight());
      }

      updateHeight() {
        document.body.style.setProperty('--orelvon-halloween-bar-height', this.hidden ? '0px' : this.getBoundingClientRect().height + 'px');
        const group = this.closest('#header-group');
        if (!group) return;
        let groupHeight = Array.from(group.children).reduce((height, element) => height + element.offsetHeight, 0);
        const header = group.querySelector('#header-component');
        if (header?.hasAttribute('transparent') && header.parentElement?.nextElementSibling) groupHeight += header.offsetHeight;
        const measured = Math.round(groupHeight) + 'px';
        if (document.body.style.getPropertyValue('--header-group-height') !== measured) document.body.style.setProperty('--header-group-height', measured);
      }

      now() {
        if (this.preview && Number.isFinite(this.previewNow)) return this.previewNow + performance.now() - this.startedAt;
        return Date.now();
      }

      updateCountdown() {
        if (!Number.isFinite(this.endAt)) {
          if (!this.preview) this.hideOffer();
          return;
        }
        const remaining = this.endAt - this.now();
        if (remaining <= 0) {
          this.hideOffer();
          return;
        }
        const total = Math.ceil(remaining / 1000);
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor(total / 3600) % 24,
          minutes: Math.floor(total / 60) % 60,
          seconds: total % 60
        };
        Object.entries(values).forEach(([unit, value]) => {
          if (this.units[unit]) this.units[unit].textContent = String(value).padStart(2, '0');
        });
      }

      hideOffer() {
        clearInterval(this.timer);
        this.closeOffer(false);
        this.hidden = true;
        this.updateHeight();
        this.queueHeight();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orelvon-halloween-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orelvon-halloween-price')) {
    customElements.define('orelvon-halloween-price', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.endAt = Date.parse(this.dataset.endAt?.trim() || '');
        this.previewNow = Date.parse(this.dataset.previewNow?.trim() || '');
        this.preview = this.dataset.preview === 'true';
        this.startedAt = performance.now();
        this.abort = new AbortController();
        window.addEventListener('pageshow', () => this.checkExpiry(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.checkExpiry();
        }, { signal: this.abort.signal });
        this.checkExpiry();
      }

      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.expiryTimer);
        this.initialized = false;
      }

      checkExpiry() {
        clearTimeout(this.expiryTimer);
        const now = this.preview && Number.isFinite(this.previewNow) ? this.previewNow + performance.now() - this.startedAt : Date.now();
        const expired = !Number.isFinite(this.endAt) || this.endAt <= now;
        this.hidden = expired;
        const fallback = this.parentElement?.querySelector('[data-halloween-base-price]');
        if (fallback) fallback.hidden = !expired;
        if (!expired) this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(this.endAt - now + 25, 86400000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orelvon-halloween-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orelvon-halloween-product-offer')) {
    customElements.define('orelvon-halloween-product-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.preview = this.dataset.preview === 'true';
        this.endAt = Date.parse(this.dataset.endAt?.trim() || '');
        this.previewNow = Date.parse(this.dataset.previewNow?.trim() || '');
        this.startedAt = performance.now();
        this.abort = new AbortController();
        window.addEventListener('pageshow', () => this.checkExpiry(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.checkExpiry();
        }, { signal: this.abort.signal });
        this.checkExpiry();
      }

      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.expiryTimer);
        this.initialized = false;
      }

      checkExpiry() {
        clearTimeout(this.expiryTimer);
        if (!Number.isFinite(this.endAt)) {
          if (!this.preview) this.hidden = true;
          return;
        }
        const now = this.preview && Number.isFinite(this.previewNow) ? this.previewNow + performance.now() - this.startedAt : Date.now();
        const remaining = this.endAt - now;
        if (remaining <= 0) {
          this.hidden = true;
          return;
        }
        this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(remaining + 25, 86400000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
